export async function redirectAuthenticatedUser(fetcher: typeof fetch = fetch): Promise<boolean> {
  if (window.location.pathname !== "/") return false;
  try {
    const response = await fetcher("/api/auth/me", {
      credentials: "include",
      headers: { Accept: "application/json" },
      signal: AbortSignal.timeout(2500)
    });
    if (!response.ok) return false;
    window.location.replace("/app");
    return true;
  } catch {
    return false;
  }
}
